import { ApplicantRecruitmentOverviewResponse, ApplicantStatus } from '@/Models/CandidateOverview';

function canSelectCandidate(candidate: ApplicantRecruitmentOverviewResponse): boolean {
    return candidate.applicantStatus !== ApplicantStatus.Invited && !candidate.isInternal;
}

export default canSelectCandidate;
